import {Pipe, PipeTransform} from '@angular/core';
import {Ttm} from '../classes/ttm';
import {TtmTypes} from '../classes/ttm-types.enum';
import {TtmType} from '../classes/ttmtype';

@Pipe({
    name: 'countAmountOfTtms'
})
export class CountAmountOfTtmsPipe implements PipeTransform {

    transform(ttms: Ttm[], ttmType?: TtmType, ...trigger: unknown[]): unknown {
        return ttms.filter(t => !ttmType || t.type_key === ttmType.key)
            .map(t => ttmType.count ? t.amount : 1)
            .reduce((a, b) => a + b);
    }
}
